import React from "react";

function Hero(){
  return(
    <section className="h-screen flex items-center justify-center 
bg-gradient-to-r from-blue-500 to-cyan-400 
dark:from-gray-900 dark:to-black 
text-white text-center" id="home"  >

      <div className="max-w-3xl">

        <h1 className="text-5xl font-bold mb-6">
          Build Modern Websites for Your Business
        </h1>

        <p className="text-xl mb-8">
          I design and develop fast, responsive and modern web applications.
        </p>

        <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
          Get Started
        </button>

      </div>

    </section>
  );
}

export default Hero;